@if (shouldShowMasterReference() && this.store.incident()?.masterIncidentId; as masterIncidentId) {
  <div class="main-container" [class.section-disabled]="this.store.isPending()">
    <h2 class="h1-medium">Master Reference</h2>
    <div class="references-container">
      <div class="reference-container">
        <a class="text-content" [href]="getIncidentUrl(masterIncidentId)" target="_blank">
          <mat-icon class="link-icon">link</mat-icon>
          <span>INCIDENT ID {{ masterIncidentId }}</span>
        </a>
      </div>
    </div>
  </div>
} @else if (shouldShowDuplicateReferences()) {
  <div class="main-container" [class.section-disabled]="this.store.isPending()">
    <h2 class="h1-medium">Duplicate References</h2>
    <div class="references-container">
      @for (incidentDuplicateId of duplicateIncidentIds(); track incidentDuplicateId) {
        <div class="reference-container">
          <a class="text-content" [href]="getIncidentUrl(incidentDuplicateId)" target="_blank">
            <mat-icon class="link-icon">link</mat-icon>
            <span>INCIDENT ID {{ incidentDuplicateId }}</span>
          </a>
        </div>
      }
    </div>
  </div>
}
